<template>
  <div class="account tableStyle">
    <el-row>
      <el-col :span="24">
        <div class="tab-info">
          <div class="tab-child" @click="changeStatus(5)">
            <el-card class="tab-child" :class="{active: currentStatus == 5}">
              <div class="child-info">未对账:</div>
              <div class="child-num">{{ headerData.un_checked }}</div>
            </el-card>
          </div>
          <div class="tab-child" @click="changeStatus(100)">
            <el-card class="tab-child" :class="{active: currentStatus == 100}">
              <div class="child-info">已对账:</div>
              <div class="child-num">{{ headerData.checked }}</div>
            </el-card>
          </div>
          <div class="tab-child" @click="changeStatus(10)">
            <el-card class="tab-child" :class="{active: currentStatus == 10}">
              <div class="child-info">异议:</div>
              <div class="child-num">{{ headerData.check_deagree }}</div>
            </el-card>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-form class="queryForm" size="small" inline>
        <el-form-item label="厂商/物业ID：" class="screen">
          <el-input v-model="queryForm.query_columns.cid" placeholder="请输入厂商/物业ID" style="width: 150px" clearable @change="getTableList('query')"></el-input>
        </el-form-item>
        <el-form-item label="厂商/物业名称：" class="screen">
          <el-select v-model="queryForm.query_columns.company_name" placeholder="请选择" clearable @change="getTableList('query')">
            <el-option v-for="(item, index) in allManufacturer" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期：" class="screen">
          <el-date-picker
            v-model="time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 300px"
            @change="timeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否超时：" class="screen">
          <el-select v-model="queryForm.query_columns.expired" placeholder="请选择" style="width: 150px" clearable @change="getTableList('query')">
            <el-option label="未超时" :value="0"></el-option>
            <el-option label="已超时" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话：" class="screen">
          <el-input v-model="queryForm.query_columns.company_mobile" placeholder="请输入联系电话" style="width: 150px" clearable @change="getTableList('query')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
        
        <!-- <el-form-item>
          <el-button size="small" @click="download">导出数据</el-button>
              <el-button size="small" @click="goPrint">打印</el-button>
        </el-form-item> -->
        
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-button size="small" @click="download">导出数据</el-button>
        <el-button size="small" @click="goPrint">打印</el-button>
      </el-col>
    </el-row>
    <div class="tableArea">
      <el-table :data="tableData" class="table-border" @select="select" ref="table" height="100%">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="ID" prop="company_id" align="center" width="70"></el-table-column>
        <el-table-column label="厂商/物业名称" prop="company_name" align="center"></el-table-column>
        <el-table-column label="类型" prop="company_type_txt" align="center"></el-table-column>
        <el-table-column label="分账周期" align="center" width="200">
          <template slot-scope="scope">
            {{scope.row.start_time}} 至 {{scope.row.end_time}}
          </template>
        </el-table-column>
        <el-table-column label="总电量(kWh)" prop="p_power" align="center"></el-table-column>
        <el-table-column label="结算单价" prop="fee_val" align="center"></el-table-column>
        <el-table-column label="结算金额" prop="fee" align="center"></el-table-column>
        <!-- <el-table-column label="确认对账" prop="status" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">生成</span>
            <span v-else-if="scope.row.status == 5">已分发</span>
            <span v-else-if="scope.row.status == 10">异议</span>
            <span v-else-if="scope.row.status == 12">运营修改</span>
            <span v-else-if="scope.row.status == 15">再分发</span>
            <span v-else-if="scope.row.status == 100">已对账</span>
            <span v-else>-</span>
            <span v-if="scope.row.status === 1 || scope.row.status === 5 || scope.row.status === 12 || scope.row.status === 15">未对账</span>
            <span v-else-if="scope.row.status === 10">异议</span>
            <span v-else-if="scope.row.status === 100">已对账</span>
            <span v-else>-</span>
          </template>
        </el-table-column> -->
        <el-table-column label="对账截止日期" prop="limit_time" align="center"></el-table-column>
        <el-table-column label="确认日期" align="center" v-if="currentStatus == 100">
          <template slot-scope="scope">
            <span v-if="scope.row.confirm_time" style="color: red">{{scope.row.confirm_time}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="超时天数" prop="expire_day" align="center"></el-table-column>
        <el-table-column label="联系电话" prop="company_mobile" align="center" width="110"></el-table-column>

        <el-table-column label="操作" align="center" width="170">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="goDetail(scope.row)">明细</el-button>
            <el-button v-if="scope.row.status == 10" type="primary" plain size="mini" @click="reSend(scope.row)">
              重新分发
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
    </div>

    <div class="pageFoot flex">
      <div class="tongji">
        统计：总电量（{{pageData.static_powers}}kWh）
        &nbsp;总结算金额（{{pageData.static_fee}}元）
        <!-- &nbsp;已分发账单（{{pageData.static_has_publish}}）
        &nbsp;未分发账单（{{pageData.static_no_publish}}） -->
        &nbsp;已确认对账（{{pageData.static_checked}}）
        &nbsp;未确认对账（{{pageData.static_un_checked}}）
      </div>
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="queryForm.size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog
        title="提示"
        width="30%"
        custom-class="dialogRadius"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        :before-close="closeDialog">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto" size="small">
            <div class="warning">是否确认将账单发送给已选中的厂商？</div>
            <el-form-item label="对账截至日期：" prop="limit_time">
                <el-date-picker
                    v-model="addForm.limit_time"
                    type="date"
                    :value-format="'yyyy-MM-dd'"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div class="tips">
          提示：若厂商未在对账截至日期前确认对账即为默认通过
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取 消</el-button>
            <el-button size="small" type="primary" @click="send">确 定</el-button>
        </span>
    </el-dialog>

    <Detail v-if="isDetailShow" :isVisible="isDetailShow" :info="detailInfo" @close="closeDetail"></Detail>
  </div>
</template>
<script>
import Detail from './detail.vue';
export default {
  data() {
    return {
        size: 20,
        page: 1,
        total: 0,
        queryForm: {
          page: 1,
          size: 20,
          query_columns: {
            cid: '', //厂商id
            company_name: '', //厂商名称
            company_mobile: '', //厂商电话
            status: '', //账单状态，0取消无效，1生成(未对账)，10厂商异议，100对账成功
            expired: '', //是否超时
            start_time: '',
            end_time: '',
            is_publish: 1,
            check_status: 5,
          }
        },
        currentStatus: 5,
        time: [],
        tableData: [],
        pageData: {
          static_checked: 0, //确认对账
          static_fee: 0, //结算金额
          static_has_publish: 0, //已分发
          static_no_publish: 0, //未分发
          static_powers: 0, //总电量
          static_un_checked: 0, //未对账
        },
        headerData: {
          check_deagree: 0,
          checked: 0,
          un_checked: 0
        },

        selectedMenu: [],
        allManufacturer: [],

        dialogVisible: false,
        addForm:{
            limit_time: ''
        },
        rules: {
            limit_time: [
                {required: true, message: '请选择截止日期', trigger: 'blur'},
            ]
        },

        isDetailShow: false,
        detailInfo: {},
    };
  },
  components: {
    Detail
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
        this.getTableList();
        this.getAllManufacturer();
    },
    // 获取table
    getTableList(type){
        if(type === 'query'){
          this.queryForm.page = 1;
        }
        this.$http.post(this.common.admin + "/api/reconciliationList", this.queryForm).then((res) => {
          if (res.code === 200) {
            this.total = res.data.count;
            this.tableData = res.data.list;
            this.pageData = res.data.statistic;
            this.headerData = res.data.statistic_header;
          } else {
            return this.$message.error(res.msg);
          }
        });
    },
    // 获取所有厂商列表
    getAllManufacturer(){
      this.$http.get(this.common.admin+'/admin/companyAllList').then(res => {
        if(res.code === 200){
          this.allManufacturer = res.data;
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    resetQuery(){
      this.queryForm.query_columns = {
        cid: '', //厂商id
        company_name: '', //厂商名称
        company_mobile: '', //厂商电话
        status: '', //账单状态，0取消无效，1生成(未对账)，10厂商异议，100对账成功
        expired: '', //是否超时
        start_time: '',
        end_time: '',
        is_publish: 1,
        check_status: this.currentStatus
      };
      this.getTableList('query');
    },
    // 修改状态
    changeStatus(type){
      this.currentStatus = type;
      this.queryForm.query_columns.check_status = type;
      this.getTableList('query');
    },
    // 打开新建弹窗
    openDialog(){
      if(this.selectedMenu.length === 0){
        return this.$message.info('请先选择要分发账单的厂商');
      }else{
        this.dialogVisible = true;
      }
    },
    // 重新分发
    reSend(data){
      this.$confirm('是否确定重新分发该厂商的账单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectedMenu.push(data.id);
        this.openDialog();
      }).catch(() => {
        this.selectedMenu = [];
      });
    },
    // 关闭新建弹窗
    closeDialog(){
      this.dialogVisible = false;
      this.addForm = {
        limit_time: ''
      };
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
    },
    // 确认新建套餐
    send(){
      this.$refs.addForm.validate(v => {
        if(v === true){
          let params = {
            limit_time: this.addForm.limit_time,
            ids: this.selectedMenu
          };
          this.$http.post(this.common.admin + '/api/reconciliationListPublish', params).then(res => {
              if(res.code === 200){
                  this.$message.success('账单已分发');
                  this.selectedMenu = [];
                  this.closeDialog();
                  this.getTableList();
              }else{
                return this.$message.error(res.msg);
              }
          });
        }else{
          return this.$message.error('请将信息填写完整');
        }
      });
    },
    // 翻页
    changePage(page) {
      this.queryForm.page = page;
      this.getTableList();
    },
    sizeChange(val){
      this.queryForm.size = val;    
      this.getTableList('query');
    },
    // 修改时间
    timeChange(time){
      this.queryForm.query_columns.start_time = time[0];
      this.queryForm.query_columns.end_time = time[1];
      this.getTableList('query');
    },
    handleSelectionChange(data){
      // console.log(data);
    },
    select(selection, row){
      // console.log(selection, row);
      if(row.is_publish === 1){
        this.$refs.table.toggleRowSelection(row, false);
        return this.$message.warning('该厂商的账单已分发，请勿重复选择');
      }else{
        this.selectedMenu.push(row.id);
      }
    },
    // 查看厂商明细
    goDetail(data){
      this.detailInfo = data;
      this.isDetailShow = true;
    },
    // 关闭详情
    closeDetail(){
      this.detailInfo = {};
      this.isDetailShow = false;
    },
    // 打开打印预览
    goPrint(){

      if(this.tableData.length === 0){
        return this.$message.warning('当前页面没有可打印数据');
      }

      let routeData = this.$router.resolve({
        path: "/distributedPrint",
        query: this.queryForm.query_columns,
      });
      window.open(routeData.href, '_blank');
    },
    // 导出
    download(){
      let params = Object.assign({},this.queryForm);
      params.export = 1;
      this.$http.post(this.common.admin + '/api/reconciliationList', params, {
        responseType: "blob"
      }).then(res => {
        if(res.code === 400){
          return this.$message.error(res.msg);
        }else{
          let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"}); // 为blob设置文件类型，这里以.xlsx为例
          let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
          let a = document.createElement("a");
          a.href = url;
          a.click();
          // 释放这个临时的对象url
          window.URL.revokeObjectURL(url); 
        }
      });
    }
  },
};
</script>
<style lang="less" scoped>
.account {
  height: 100%;
  display: flex;
  flex-direction: column;

  .tab-info {
    display: flex;
    /*justify-content: space-around;*/

    .tab-child {
      margin-right: 37px;
      width: 240px;
      min-height: 74px;
      color: #000000;
      border-radius: 6px;
      cursor: pointer;

      &.active{
        background-color: var(--main-theme-color);
        color: #fff;
        .child-num{
          color: #fff;
        }
      }
      /deep/.el-card{
        // box-shadow: 0 2px 6px 0 rgba(248, 249, 250,.1);
        box-shadow: 0 2px 6px 0 #f8f9fa;
      }
      /deep/.el-card__body{
        display: flex;
        align-items: center;
      }

      .child-info {
        font-size: 20px;
      }

      .child-num {
        font-size: 3vh;
        margin-left: 12px;
        // margin-top: 10px;
        font-weight: 500;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        color: var(--main-theme-color);
        font-weight: bold;
        font-size: 30px;
      }
    }
  }
  .queryForm{
    margin-top: 20px;

    // /deep/.el-form-item{
    //   margin-bottom: 0;
    // }
  }
  .tableArea{
    flex: 1;
    margin-top: 10px;
    min-height: calc(100% - 306px);
    /deep/.el-card{
      height: 100%;
      .el-card__body{
        height: 100%;
        padding: 0px;
      }
    }
  }
  /deep/.dialogRadius{
    .warning{
      margin-bottom: 20px;
      font-size: 16px;
    }
    .tips{
      font-size: 14px;
      color: #606266;
    }
    &.printDialog{
      width: 80%;
      .table-head{
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        .title{
          font-size: 24px;
          font-weight: 500;
          color: #161616;
        }
      }
      .table-border{
        border-right: 1px solid #F4F5F7;
        border-bottom: 1px solid #F4F5F7;
      }
    }
  }
  .pageFoot{
    justify-content: space-between;
    .tongji{
      font-size: 14px;
    }
  }
}
/deep/.el-range-input{
  background-color: transparent;
}
</style>